import React from "react";

import { Route } from "@mapmycustomers/shared/types/entity";

import styles from "./RouteName.module.scss";

interface Props {
  items?: React.ReactNode;
  route: Route;
}

const RouteName: React.FC<Props> = ({ items, route }) => (
  <div className={styles.container}>
    <div className={styles.details}>
      <div className={styles.name}>{route.name}</div>
      {items && <div className={styles.items}>{items}</div>}
    </div>
  </div>
);

export default RouteName;
